/* eslint-disable react/prop-types */
import CustomSelect from '@shared/components/customSelect'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import playerPlaceholder from '@assets/images/placeholder/Placeholder_Player.svg'
import rightIcon from '@assets/images/icon/right.svg'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import { getImgURL } from '@shared-submodule/utils'

function PlayerFilter({ matchDetail, playerData, currentTeamId, handlePlayersData, setTypeWiseRun }) {
  const [isAll, setIsAll] = useState(true)
  const [selectedBatters, setSelectedBatters] = useState([])
  const [selectedBowler, setSelectedBowler] = useState(null)

  const score = currentTeamId === matchDetail?.oTeamScoreA?.oTeam?._id ? matchDetail?.oTeamScoreA : matchDetail?.oTeamScoreB

  // ?ALL BOWLERS
  const playersSelect = playerData?.aBowlers?.map(p => ({
    sLabel: p?.oBowler?.sFullName,
    sValue: p?.iBowlerId
  }))

  // ?ALL BATTERS
  const players = playerData?.aBatters?.map(p => ({
    sName: p?.oBatter?.sFullName,
    nRuns: p?.nRuns,
    id: p?.iBatterId,
    img: p?.oBatter?.oImg?.sUrl
  }))

  useEffect(() => {
    if (playerData) {
      const batterIds = playerData?.aBatters?.map(p => p?.iBatterId)
      setSelectedBatters(batterIds)
      setIsAll(true)
      setSelectedBowler(null)
    }
  }, [playerData])

  // !FILTER DATA BATTER WISE
  function handlePlayer(t) {
    const batterIds = playerData?.aBatters?.map(p => p?.iBatterId)
    if (t === 'all') {
      const newIsAll = !isAll
      if (!newIsAll && setTypeWiseRun) setTypeWiseRun({})
      setIsAll(newIsAll)
      setSelectedBatters(newIsAll ? batterIds : [])
      handlePlayersData(newIsAll ? batterIds : [], selectedBowler?.sValue || null)
    } else {
      const updatedPlayers = selectedBatters?.includes(t) ? selectedBatters?.filter(i => i !== t) : [...selectedBatters, t]

      setIsAll(updatedPlayers.length === batterIds.length)
      setSelectedBatters(updatedPlayers)
      handlePlayersData(updatedPlayers.length === 0 ? [] : updatedPlayers, selectedBowler?.sValue || null)
    }
  }

  function handleBowler(d) {
    setSelectedBowler(d)
    handlePlayersData(selectedBatters, d?.sValue || null)
  }
  return (
    <div className="common-box p-0 mt-2 pt-2 ">
      <Row className={'d-flex align-items-center m-2 w-full'}>
        {/* <Col xl={2}>Select Player</Col> */}
        <Col>
          <div className="d-flex w-full align-items-center gap-2">
            <h6 style={{ whiteSpace: 'nowrap' }}>Select Bowler -</h6>
            <div style={{ width: '100%' }}>
              <CustomSelect
                labelKey="sLabel"
                valueKey="sValue"
                placeholder="Choose player"
                value={selectedBowler}
                options={playersSelect}
                isClearable
                onChange={e => handleBowler(e)}
                className="w-full"
              />
            </div>
          </div>
        </Col>
      </Row>
      <div className="">
        <hr className={styles.divider} />
        <div className={'d-flex justify-content-between align-items-center px-4'}>
          <div onClick={() => handlePlayer('all')} className="cursor-pointer d-flex align-items-center">
            <span className={`${styles.customRadio} ${isAll && styles.selected}`}>
              {isAll && <MyImage src={rightIcon} height={14} width={14} />}
            </span>
            <h6 className="mx-3 my-0 font-bold">All Batsman</h6>
          </div>
          <div>{score?.sScoresFull}</div>
        </div>
        {players?.map((p, i) => {
          return (
            <>
              <hr className={styles.divider} />
              <div key={i} className={`d-flex justify-content-between align-items-center px-4 ${i === players.length - 1 ? 'pb-3' : ''} `}>
                <div onClick={() => handlePlayer(p?.id)} className="cursor-pointer d-flex align-items-center">
                  <span className={`${styles.customRadio} ${selectedBatters?.includes(p?.id) && styles.selected}`}>
                    {selectedBatters?.includes(p?.id) && <MyImage className={styles.icon} src={rightIcon} height={14} width={14} />}
                  </span>
                  <div className="mx-2 ">
                    <MyImage className={styles.playerImg} src={p?.img ? getImgURL(p?.img) : playerPlaceholder} height={38} width={38} />
                  </div>
                  <span>{p.sName}</span>
                </div>
                <div>{p.nRuns}</div>
              </div>
            </>
          )
        })}
      </div>
    </div>
  )
}

export default PlayerFilter
